module.exports = __webpack_public_path__ + "static/media/Office Metal Chair.2eaf2919.jpg";